import httpClient from "../../../../../shared/api/httpClient";
import { qs } from "../../../../../shared/api/qs";

function requireStockCountId(stockCountId) {
  if (!stockCountId) throw new Error("El ID del conteo de stock es requerido");
}

function requireLineId(lineId) {
  if (!lineId) throw new Error("El ID de la línea de conteo es requerido");
}

export function getStockCounts({ page = 1, signal } = {}) {
  const query = qs({ page });
  return httpClient.get(`/stock/counts${query}`, { signal });
}

export function getStockCount(stockCountId, { signal } = {}) {
  requireStockCountId(stockCountId);
  return httpClient.get(`/stock/counts/${stockCountId}`, { signal });
}

export function getStockCountItems(
  stockCountId,
  {
    page = 1,
    itemType,
    categoryId,
    sector,
    adjustmentType,
    withAdjustments,
    search,
    signal,
  } = {}
) {
  requireStockCountId(stockCountId);
  const query = qs({
    page,
    itemType,
    categoryId,
    sector,
    adjustmentType,
    withAdjustments,
    search,
  });
  return httpClient.get(`/stock/counts/${stockCountId}/items${query}`, {
    signal,
  });
}

export function getStockCountCategoryOptions({ signal } = {}) {
  return httpClient.get("/stock/ingredient-categories/options", { signal });
}

export function updateStockCountItemAdjustment(stockCountId, lineId, data) {
  requireStockCountId(stockCountId);
  requireLineId(lineId);
  return httpClient.patch(
    `/stock/counts/${stockCountId}/items/${lineId}/adjustment`,
    data
  );
}

export function approveStockCount(stockCountId) {
  requireStockCountId(stockCountId);
  return httpClient.post(`/stock/counts/${stockCountId}/approve`);
}

export function getStockCountCreatePreview({ scope, sharedItemsSector, signal } = {}) {
  const query = qs({ scope, sharedItemsSector });
  return httpClient.get(`/stock/counts/create-preview${query}`, { signal });
}

export function createStockCount(payload) {
  return httpClient.post("/stock/counts", payload);
}

export function cancelStockCount(id) {
  requireStockCountId(id);
  return httpClient.post(`/stock/counts/${id}/cancel`);
}
